import React from 'react';

const AboutUs = () => {
  return (
    <div>
      <section className="section section-bg" id="call-to-action" style={{ backgroundImage: "url(assets/images/pine.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="cta-content">
                <br />
                <br />
                <h2>Learn more <em>About Us</em></h2>
                <p>The History of VVIP Mobile Coffee bar</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" id="our-classes">
        <div className="container">
          <br />
          <br />
          <br />
          <div className="row" id="tabs">
            <div className="col-lg-4">
              <ul>
                <li><a href='#tabs-1'><i className="fa fa-soccer-ball-o"></i> Our Goals</a></li>
                <li><a href='#tabs-2'><i className="fa fa-briefcase"></i> Our Work</a></li>
                <li><a href='#tabs-3'><i className="fa fa-heart"></i> Our Passion</a></li>
              </ul>
            </div>
            <div className="col-lg-8">
              <section className='tabs-content'>
                <article id='tabs-1'>
                  <img src="assets/images/vvipcar.jpg" alt="" />
                  <h4>Introduction</h4>

                  <p>VVIP Mobile Coffee Bar is a movable Beverage cart that’s hand driven on Wheels to serve Functions and Events.</p>
                  <p>It’s a Family Owned Business, where we major in Coffees and Cocktails on; Showers - Birthday, Baby showers, Bridal,  House Parties, Wedding Ceremonies, Engagements, Conferences and many more...</p>
                </article>
                <article id='tabs-2'>
                  <img src="assets/images/vvipgals.jpg" alt="" />
                  <h4>Our Work</h4>
                  <p>We launched in November 2020 on a Fundraising Event(Car wash), this was our very first Event, very amazing to serve a mass of people with Coffees and Cocktails.
                  We make Events memorable, Taste the Love at Our Great Service with a blend of Coffee in Your Cocktail.
                  </p>

                </article>
                <article id='tabs-3'>
                  <img src="assets/images/barista.jpg" alt="" />
                  <h4>Our Passion</h4>
                  <p>We are only 2 people on the Team ie: my Girlfriend(Ritah Kyomuhendo) and I(Farruk Muwanga) that are running this Cart.
Looking forward to make more Mobile carts and have a expanded services so as avail employment to the society.</p>
                  <p>Our mission is To spread the Coffee and Cocktail Culture on Events, Ceremonies and City Streets.</p>
                </article>
              </section>
            </div>
          </div>
        </div>
      </section >

      <section className="section section-bg" id="call-to-action" style={{ backgroundImage: 'url(/assets/images/vvipgals.jpg)' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="cta-content">
                <h2>Send us a <em>message</em></h2>
                <p>Still not satisfied, you can contact us directly through our various platforms for any questions that you would like us to answer.</p>
                <div className="main-button">
                  <a href="/bookings">Contact us</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div >
  );
};

export default AboutUs;
